import { render, staticRenderFns } from "./efficiency.vue?vue&type=template&id=7c34d8a9&"
import script from "./efficiency.vue?vue&type=script&lang=js&"
export * from "./efficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports